import { render, staticRenderFns } from "./SupergroupListItem.vue?vue&type=template&id=2fc22b55&scoped=true"
import script from "./SupergroupListItem.vue?vue&type=script&lang=js"
export * from "./SupergroupListItem.vue?vue&type=script&lang=js"
import style0 from "./SupergroupListItem.vue?vue&type=style&index=0&id=2fc22b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc22b55",
  null
  
)

export default component.exports